import {getAxiosInstance} from './upload-files.service'
// import axios from "axios";
// import Cookies from 'js-cookie';
// const axiosInstance = getAxiosInstance();
// const userId = Cookies.get('userId')
const userId = JSON.parse(sessionStorage.getItem('userid'));

const apiService =  {


    UploadFile: (formdata) =>
    getAxiosInstance().post("/file", formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    ,

    GetSample: () =>
        //console.log("axiost",axiosInstance)
        getAxiosInstance().get('/samples/json/sampletable.json', {
        }),

    GetFiles: () =>
        //console.log("axiost",axiosInstance)
        getAxiosInstance().get('/file', {
        }),


    GetWorkflow: () =>
    getAxiosInstance().get('/workflow?userId=' + userId, {
        }),
    //getAxiosInstance().get('/workflow.json'),

    GetOneWorkflow: async (id) => {

        getAxiosInstance().get(`/workflow/${id}?userId=` + userId, {})
        .then(response => {
            // return response.data.name;
            return response.data;
        }).catch(err => {
            console.log(err);

        })
    },

    GetWorkflowDetails: (id) =>
    getAxiosInstance().get(`/workflowDsInfo/${id}?userId=${userId}`, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }),
    //getAxiosInstance().get(`/${id}.json`),

    CreateSampleAttribute: (formdata) => {
        return getAxiosInstance().post("/sample_attribute", formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(response => {
            return response;

        }).catch(err => {
            console.log(err);
        });
    },

    UpdateSampleAttribute: (formdata, id) => {
        return getAxiosInstance().put("/sample_attribute/" + id, formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(response => {
            return response;

        }).catch(err => {
            console.log(err);
        });
    },

    CreateSample: (formdata) => {
        return getAxiosInstance().post("/sample", formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(response => {
            return response;

        }).catch(err => {
            console.log(err);
        });
    },

    UpdateSample: (formdata, id) => {
        return getAxiosInstance().put("/sample/" + id, formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(response => {
            return response;

        }).catch(err => {
            console.log(err);
        });
    },

    CreateBulkSample: (formdata) => {
        return getAxiosInstance().post("/sample.bulk", formdata, {
            headers: {
                "Content-Type": "application/json",
            },
        }).then(response => {
            return response;
        }).catch(err => {
            console.log(err);
        });
    },

    CreateDataset: (formdata, id) =>
    getAxiosInstance().post("/dataset", formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(response => {
            return response;

        }).catch(err => {
            console.log(err);
        }),


    PatchDataset: (formdata, id) =>{
    return getAxiosInstance().patch("/dataset/" + id, formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).catch(err => {
            console.log(err);
        });
    },

    UpdateDataset: (formdata, id) =>
    getAxiosInstance().put("/dataset/" + id, formdata, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }),

    GetDataset: () =>
    getAxiosInstance().get("/dataset", {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }),

    GetDatasets: () =>
        getAxiosInstance().get('/dataset?userId=' + userId, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }),
        //getAxiosInstance().get('/datasets.json'),

    GetDataDetails: (id) =>
        getAxiosInstance().get(`/datasetdetails/${id}?userId=` + userId, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }),
       // getAxiosInstance().get(`/${id}.json`),

    AggregateDataset: (id) =>
    getAxiosInstance().post("/aggregatedataset/" + id, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }),


    // CreateDefination :  (formdata,id) =>{
    //      axiosInstance.post("/definition/",formdata ,{
    //         headers: {
    //             "Content-Type": "multipart/form-data",
    //         },
    //     });
    // },

    GetDefination: () =>
    getAxiosInstance().get("/definition", {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }),

    CreateDefination: (formdata) =>
    getAxiosInstance().post("/definition", formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    ,

    CreateWorkflow: (formdata) =>
    getAxiosInstance().post("/workflow", formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }),


    ExecuteWorkflow: (formdata, id) =>
    getAxiosInstance().post("/executeWorkflow/" + id, formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }),

    UpdateWorkflow: (formdata, id) =>
    getAxiosInstance().put("/workflow/" + id, formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    ,


    CreateDag: (formdata) =>
    getAxiosInstance().post("/dag", formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }),

    AssociateFile : (sampleId, fileId) =>{
         return getAxiosInstance().patch("/sample/" + sampleId, { fileId: fileId }).then(response => {
            return response;
        }).catch(err => {
            console.log(err);
        });;
    },

    GetWorkflowState: async(id) => {
        return await getAxiosInstance().get("/workflow/getstate/" + id).then(response =>{
            return response;
        }).catch(err =>{
            console.log("errr", err);
            return err
        })
    },

 


}

export default apiService;


